import { AnimatedTransitionCard } from "@package/ui-components";
import { type Layout } from "@package/ui-gql/index-data-access";
import {
  type LayoutPostPosition,
  type SliceWallScreenState,
} from "@package/ui-wall-engine";
import { type PropsWithChildren } from "react";
import { Post } from "../Post/Post";

type LayoutPostContainerProps = {
  layout: Layout;
  position: LayoutPostPosition;
  screen: SliceWallScreenState;
};

export function LayoutPostContainer({
  layout,
  position,
  screen,
}: PropsWithChildren<LayoutPostContainerProps>) {
  if (layout.animation?.enabled) {
    return (
      <AnimatedTransitionCard
        animation={layout.animation.option}
        node={
          <Post
            key={position.id}
            post={position.post}
            asset={position.asset}
            screen={screen}
            position={position}
          />
        }
        nodeId={position.id}
      />
    );
  }

  return (
    <Post
      key={position.id}
      post={position.post}
      asset={position.asset}
      screen={screen}
      position={position}
    />
  );
}
